/**
 * Shared pricing plan configuration used by Checkout, Signup, and Home pages.
 */
export const PLAN_CONFIG = {
  vpn_1_day: {
    display: '1.91',
    label: '1 Day Access',
    description: '1 Day Trial',
    durationLabel: '1 day access',
  },
  vpn_30_day: {
    display: '9.97',
    label: '30 Days Access',
    description: '1 Month Membership',
    durationLabel: '30 days access',
  },
  vpn_90_day: {
    display: '19.97',
    label: '90 Days Access',
    description: '3 Months Membership',
    durationLabel: '90 days access',
  },
  vpn_365_day: {
    display: '49.97',
    label: '365 Days Access',
    description: '1 Year Membership',
    durationLabel: '365 days access',
  },
};

/** Ordered list of plan keys for consistent display (1 day → 1 year). */
export const PLAN_KEYS = ['vpn_1_day', 'vpn_30_day', 'vpn_90_day', 'vpn_365_day'];
